export default __webpack_public_path__ + "static/media/owl.66845e96.svg";